var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { OptionMenu } from './option-menu';
var cls = classNames('grip-button');
export var GripButtonDefaultProps = {
  columns: 2,
  rows: 3,
  style: {
    padding: '4px',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderRadius: '4px'
  },
  gap: 2,
  colors: {
    background: 'canvas',
    border: 'transparent',
    hover: {
      border: 'mid'
    }
  },
  bumpProps: {
    size: 4,
    colors: {
      background: 'very-subtle',
      border: 'very-subtle',
      hover: {
        background: 'mid',
        border: 'mid'
      }
    }
  },
  menuProps: {
    style: {
      zIndex: 200
    }
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n  "], ["\n    position: relative;\n  "])))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    \n    ", ";\n\n    display: flex;\n    flex-direction: column;\n    gap: ", "px;\n  "], ["\n    ", ";\n    ", ";\n    \n    ", ";\n\n    display: flex;\n    flex-direction: column;\n    gap: ", "px;\n  "])), theme.REMOVE_BUTTON_STYLE, theme.APPLY_COLORS, function (_a) {
    var bumpColors = _a.bumpColors;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), theme.APPLY_COLORS({
      colors: bumpColors,
      selector: cls.dot('bump')
    }));
  }, function (_a) {
    var gap = _a.gap;
    return gap;
  })
});
var RowStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    gap: ", "px;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    gap: ", "px;\n  "])), function (_a) {
    var gap = _a.gap;
    return gap;
  })
});
var BumpStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: block;\n\n    ", "\n\n    \n  "], ["\n    display: block;\n\n    ", "\n\n    \n  "])), function (_a) {
    var size = _a.size;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n      border-radius: 50%;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n      border-radius: 50%;\n    "])), size, size);
  })
});
var MenuStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    position: absolute;\n    left: 0px;\n    margin-top: 12px;\n    z-index: 100;\n  "], ["\n    position: absolute;\n    left: 0px;\n    margin-top: 12px;\n    z-index: 100;\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'GripButton',
  Container: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Button: styled.button(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  Row: styled.span(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), RowStyles),
  Bump: styled.span.attrs(cls.attr('bump'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), BumpStyles),
  Menu: styled(OptionMenu)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), MenuStyles)
};
export var GripButton = function (props) {
  var componentProps = useComponentProps(My.NAME, GripButtonDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    style = componentProps.style,
    rows = componentProps.rows,
    gap = componentProps.gap,
    columns = componentProps.columns,
    colors = componentProps.colors,
    title = componentProps.title,
    bumpProps = componentProps.bumpProps,
    menu = componentProps.menu,
    menuProps = componentProps.menuProps,
    onMenuItemSelect = componentProps.onMenuItemSelect,
    rest = __rest(componentProps, ["className", "children", "style", "rows", "gap", "columns", "colors", "title", "bumpProps", "menu", "menuProps", "onMenuItemSelect"]);
  var _a = __read(React.useState(false), 2),
    isMenuOpen = _a[0],
    setIsMenuOpen = _a[1];
  var menuRef = useRef();
  var buttonRef = useRef();
  React.useEffect(function () {
    var handleClickOutside = function (event) {
      var _a, _b;
      if (!isMenuOpen) {
        return;
      }
      if (!(menuRef === null || menuRef === void 0 ? void 0 : menuRef.current)) {
        return;
      }
      if ((_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) {
        return; // Click inside, do nothing
      }
      if ((_b = buttonRef.current) === null || _b === void 0 ? void 0 : _b.contains(event.target)) {
        return; // Click button, fallback to normal handling
      }
      setIsMenuOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuRef, isMenuOpen]);
  var handleClick = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setIsMenuOpen(!isMenuOpen);
  };
  // interecept menu item select to close menu
  var handleMenuItemSelect = function (item) {
    setIsMenuOpen(false);
    onMenuItemSelect === null || onMenuItemSelect === void 0 ? void 0 : onMenuItemSelect(item);
  };
  return React.createElement(My.Container, __assign({}, rest), React.createElement(My.Button, {
    ref: buttonRef,
    onClick: handleClick,
    title: title,
    bumpColors: bumpProps.colors,
    style: style,
    gap: gap,
    colors: colors,
    className: cls.name(className)
  }, Array.from({
    length: rows
  }).map(function (_, i) {
    return React.createElement(My.Row, {
      gap: gap,
      key: i
    }, Array.from({
      length: columns
    }).map(function (_, j) {
      return React.createElement(My.Bump, __assign({}, bumpProps, {
        key: j
      }));
    }));
  })), menu && isMenuOpen && React.createElement(My.Menu, __assign({
    onItemSelect: handleMenuItemSelect,
    ref: menuRef,
    menu: menu
  }, menuProps)));
};
GripButton.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;